import {useEffect,useRef} from "react";
import {useQueryClient} from "@tanstack/react-query";
import {useSession} from "../lib/session";
/** Ticket text is memory-only and is dropped when the signed-in account changes. */
export function SupportCacheBoundary(){
 const session=useSession(),qc=useQueryClient();const userId=session.data?.authenticated?session.data.user.id:null,previous=useRef<string|null>(null);
 useEffect(()=>{const old=previous.current;previous.current=userId;if(old&&old!==userId){void qc.cancelQueries({queryKey:["support",old]}).then(()=>qc.removeQueries({queryKey:["support",old]}));void qc.cancelQueries({queryKey:["admin","plugin-reports",old]}).then(()=>qc.removeQueries({queryKey:["admin","plugin-reports",old]}));}},[userId,qc]);return null;
}
